export const StatGrid = ({ stats, testIdPrefix }) => (
  <dl className="grid grid-cols-2 gap-4 sm:grid-cols-3">
    {stats.map(({ label, value }) => {
      const slug = label
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");
      const isUnavailable = value === null || value === undefined || value === "";
      return (
        <div key={label} className="flex flex-col gap-0.5">
          <dt className="font-mono text-[10px] uppercase tracking-wide text-zinc-500">{label}</dt>
          <dd
            data-testid={`${testIdPrefix}-stat-${slug}`}
            className={`font-mono text-sm ${isUnavailable ? "text-zinc-600" : "text-white"}`}
          >
            {isUnavailable ? "Unavailable" : value}
          </dd>
        </div>
      );
    })}
  </dl>
);
